import { Component } from "@angular/core";
import { SvgIcon } from "@ponder-shared/utils/svgIcons";
import { SidebarButtonRouteComponent } from "./sidebar-button-route.component";

@Component({
    selector: "sidebar-profile",
    imports: [],
    templateUrl: "./sidebar-button-route.component.html"
})
export class SidebarProfileButtonComponent extends SidebarButtonRouteComponent {
    public constructor() { 
        super("Profile", SvgIcon.Profile, "", false); 
    }
}